/**
 * RMFF Community Data Snapshot Widget TypeScript
 */
function initCommunityDataSnapshot() {
    var widgets = document.querySelectorAll('.rmff-community-data-snapshot-widget');
    widgets.forEach(function (widget) {
        // Initialize the widget
        setupNavigation(widget);
    });
}
function setupNavigation(widget) {
    var topicTriggers = widget.querySelectorAll('.rmff-topic-trigger');
    var subtopicTriggers = widget.querySelectorAll('.rmff-subtopic-trigger');
    var graphTriggers = widget.querySelectorAll('.rmff-graph-trigger');
    var placeholder = widget.querySelector('.rmff-content-placeholder');
    // Dropdown elements
    var topicDropdown = widget.querySelector('[data-dropdown-type="topic"]');
    var subtopicDropdown = widget.querySelector('[data-dropdown-type="subtopic"]');
    var graphDropdown = widget.querySelector('[data-dropdown-type="graph"]');
    var currentTopic = 0;
    var currentSubtopic = 0;
    var currentGraph = 0;
    var urlParams = getURLParameters();
    initializeFromURL(widget, urlParams);
    // Initialize dropdowns
    initializeDropdowns(widget);
    // Populate dropdowns with initial data
    populateSubtopicDropdown(widget, currentTopic);
    populateGraphDropdown(widget, currentTopic, currentSubtopic);
    // Desktop button click handlers
    topicTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            var topicIndex = parseInt(trigger.getAttribute('data-topic-index') || '0');
            selectTopic(widget, topicIndex);
        });
    });
    subtopicTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            var topicIndex = parseInt(trigger.getAttribute('data-topic-index') || '0');
            var subtopicIndex = parseInt(trigger.getAttribute('data-subtopic-index') || '0');
            selectSubtopic(widget, topicIndex, subtopicIndex);
        });
    });
    graphTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            var topicIndex = parseInt(trigger.getAttribute('data-topic-index') || '0');
            var subtopicIndex = parseInt(trigger.getAttribute('data-subtopic-index') || '0');
            var graphIndex = parseInt(trigger.getAttribute('data-graph-index') || '0');
            selectGraph(widget, topicIndex, subtopicIndex, graphIndex);
        });
    });
    function initializeDropdowns(widget) {
        // Helper function to close all dropdowns
        var closeAllDropdowns = function () {
            widget.querySelectorAll('.rmff-dropdown-list').forEach(function (list) {
                list.classList.remove('open');
            });
            widget.querySelectorAll('.rmff-dropdown-trigger').forEach(function (trigger) {
                trigger.classList.remove('active');
            });
        };
        // Topic dropdown
        if (topicDropdown) {
            var topicTrigger_1 = topicDropdown.querySelector('.rmff-dropdown-trigger');
            var topicList_1 = topicDropdown.querySelector('.rmff-dropdown-list');
            var topicItems_1 = topicDropdown.querySelectorAll('.rmff-dropdown-item');
            topicTrigger_1.addEventListener('click', function () {
                var isCurrentlyOpen = topicList_1.classList.contains('open');
                // Close all dropdowns first
                closeAllDropdowns();
                // If this dropdown was not open, open it
                if (!isCurrentlyOpen) {
                    topicList_1.classList.add('open');
                    topicTrigger_1.classList.add('active');
                }
            });
            topicItems_1.forEach(function (item) {
                item.addEventListener('click', function () {
                    var topicIndex = parseInt(item.getAttribute('data-topic-index') || '0');
                    selectTopic(widget, topicIndex);
                    // Update dropdown display
                    var selectedText = item.textContent || '';
                    var selectedSpan = topicTrigger_1.querySelector('.rmff-dropdown-selected');
                    if (selectedSpan)
                        selectedSpan.textContent = selectedText;
                    // Update selected state
                    topicItems_1.forEach(function (i) { return i.classList.remove('selected'); });
                    item.classList.add('selected');
                    // Close dropdown
                    topicList_1.classList.remove('open');
                    topicTrigger_1.classList.remove('active');
                });
            });
        }
        // Sub-topic dropdown
        if (subtopicDropdown) {
            var subtopicTrigger_1 = subtopicDropdown.querySelector('.rmff-dropdown-trigger');
            var subtopicList_1 = subtopicDropdown.querySelector('.rmff-dropdown-list');
            subtopicTrigger_1.addEventListener('click', function () {
                var isCurrentlyOpen = subtopicList_1.classList.contains('open');
                // Close all dropdowns first
                closeAllDropdowns();
                // If this dropdown was not open, open it
                if (!isCurrentlyOpen) {
                    subtopicList_1.classList.add('open');
                    subtopicTrigger_1.classList.add('active');
                }
            });
        }
        // Graph dropdown
        if (graphDropdown) {
            var graphTrigger_1 = graphDropdown.querySelector('.rmff-dropdown-trigger');
            var graphList_1 = graphDropdown.querySelector('.rmff-dropdown-list');
            graphTrigger_1.addEventListener('click', function () {
                var isCurrentlyOpen = graphList_1.classList.contains('open');
                // Close all dropdowns first
                closeAllDropdowns();
                // If this dropdown was not open, open it
                if (!isCurrentlyOpen) {
                    graphList_1.classList.add('open');
                    graphTrigger_1.classList.add('active');
                }
            });
        }
        // Close dropdowns when clicking outside
        document.addEventListener('click', function (e) {
            var target = e.target;
            if (!target.closest('.rmff-dropdown-container')) {
                closeAllDropdowns();
            }
        });
    }
    function updateDropdownSelections(widget, topicIndex, subtopicIndex, graphIndex) {
        // Update topic dropdown
        var topicDropdown = widget.querySelector('[data-dropdown-type="topic"]');
        if (topicDropdown) {
            var topicTrigger = topicDropdown.querySelector('.rmff-dropdown-trigger');
            var topicItems = topicDropdown.querySelectorAll('.rmff-dropdown-item');
            var selectedTopicItem = topicDropdown.querySelector("[data-topic-index=\"".concat(topicIndex, "\"]"));
            if (selectedTopicItem) {
                var selectedText = selectedTopicItem.textContent || '';
                var selectedSpan = topicTrigger.querySelector('.rmff-dropdown-selected');
                if (selectedSpan)
                    selectedSpan.textContent = selectedText;
                topicItems.forEach(function (item) { return item.classList.remove('selected'); });
                selectedTopicItem.classList.add('selected');
            }
        }
        // Update sub-topic dropdown
        var subtopicDropdown = widget.querySelector('[data-dropdown-type="subtopic"]');
        if (subtopicDropdown) {
            var subtopicTrigger = subtopicDropdown.querySelector('.rmff-dropdown-trigger');
            var subtopicItems = subtopicDropdown.querySelectorAll('.rmff-dropdown-item');
            var selectedSubtopicItem = subtopicDropdown.querySelector("[data-topic-index=\"".concat(topicIndex, "\"][data-subtopic-index=\"").concat(subtopicIndex, "\"]"));
            if (selectedSubtopicItem) {
                var selectedText = selectedSubtopicItem.textContent || '';
                var selectedSpan = subtopicTrigger.querySelector('.rmff-dropdown-selected');
                if (selectedSpan)
                    selectedSpan.textContent = selectedText;
                subtopicItems.forEach(function (item) { return item.classList.remove('selected'); });
                selectedSubtopicItem.classList.add('selected');
            }
        }
        // Update graph dropdown
        var graphDropdown = widget.querySelector('[data-dropdown-type="graph"]');
        if (graphDropdown) {
            var graphTrigger = graphDropdown.querySelector('.rmff-dropdown-trigger');
            var graphItems = graphDropdown.querySelectorAll('.rmff-dropdown-item');
            var selectedGraphItem = graphDropdown.querySelector("[data-topic-index=\"".concat(topicIndex, "\"][data-subtopic-index=\"").concat(subtopicIndex, "\"][data-graph-index=\"").concat(graphIndex, "\"]"));
            if (selectedGraphItem) {
                var selectedText = selectedGraphItem.textContent || '';
                var selectedSpan = graphTrigger.querySelector('.rmff-dropdown-selected');
                if (selectedSpan)
                    selectedSpan.textContent = selectedText;
                graphItems.forEach(function (item) { return item.classList.remove('selected'); });
                selectedGraphItem.classList.add('selected');
            }
        }
    }
    function populateSubtopicDropdown(widget, topicIndex) {
        var subtopicDropdown = widget.querySelector('[data-dropdown-type="subtopic"]');
        if (!subtopicDropdown)
            return;
        var subtopicList = subtopicDropdown.querySelector('.rmff-dropdown-list');
        var subtopicTrigger = subtopicDropdown.querySelector('.rmff-dropdown-trigger');
        // Clear existing items
        subtopicList.innerHTML = '';
        // Get sub-topics for the selected topic
        var subtopicItems = widget.querySelectorAll(".rmff-subtopic-item[data-topic-index=\"".concat(topicIndex, "\"]"));
        if (subtopicItems.length > 0) {
            subtopicItems.forEach(function (item, index) {
                var button = item.querySelector('.rmff-subtopic-trigger');
                var subtopicName = button.textContent || '';
                var subtopicSlug = button.getAttribute('data-subtopic-slug') || '';
                var topicSlug = button.getAttribute('data-topic-slug') || '';
                var dropdownItem = document.createElement('div');
                dropdownItem.className = "rmff-dropdown-item ".concat(index === 0 ? 'selected' : '');
                dropdownItem.setAttribute('data-topic-index', topicIndex.toString());
                dropdownItem.setAttribute('data-subtopic-index', index.toString());
                dropdownItem.setAttribute('data-topic-slug', topicSlug);
                dropdownItem.setAttribute('data-subtopic-slug', subtopicSlug);
                dropdownItem.setAttribute('data-dropdown-type', 'subtopic');
                dropdownItem.textContent = subtopicName;
                dropdownItem.addEventListener('click', function () {
                    selectSubtopic(widget, topicIndex, index);
                    // Update dropdown display
                    var selectedSpan = subtopicTrigger.querySelector('.rmff-dropdown-selected');
                    if (selectedSpan)
                        selectedSpan.textContent = subtopicName;
                    // Update selected state
                    subtopicList.querySelectorAll('.rmff-dropdown-item').forEach(function (i) { return i.classList.remove('selected'); });
                    dropdownItem.classList.add('selected');
                    // Close all dropdowns
                    widget.querySelectorAll('.rmff-dropdown-list').forEach(function (list) {
                        list.classList.remove('open');
                    });
                    widget.querySelectorAll('.rmff-dropdown-trigger').forEach(function (trigger) {
                        trigger.classList.remove('active');
                    });
                });
                subtopicList.appendChild(dropdownItem);
            });
            // Update trigger text
            var firstSubtopic = subtopicItems[0].querySelector('.rmff-subtopic-trigger');
            var selectedSpan = subtopicTrigger.querySelector('.rmff-dropdown-selected');
            if (selectedSpan && firstSubtopic) {
                selectedSpan.textContent = firstSubtopic.textContent || '';
            }
        }
    }
    function populateGraphDropdown(widget, topicIndex, subtopicIndex) {
        var graphDropdown = widget.querySelector('[data-dropdown-type="graph"]');
        if (!graphDropdown)
            return;
        var graphList = graphDropdown.querySelector('.rmff-dropdown-list');
        var graphTrigger = graphDropdown.querySelector('.rmff-dropdown-trigger');
        // Clear existing items
        graphList.innerHTML = '';
        // Get graphs for the selected sub-topic
        var graphItems = widget.querySelectorAll(".rmff-graph-item[data-topic-index=\"".concat(topicIndex, "\"][data-subtopic-index=\"").concat(subtopicIndex, "\"]"));
        if (graphItems.length > 0) {
            graphItems.forEach(function (item, index) {
                var button = item.querySelector('.rmff-graph-trigger');
                var graphName = button.textContent || '';
                var graphSlug = button.getAttribute('data-graph-slug') || '';
                var topicSlug = button.getAttribute('data-topic-slug') || '';
                var subtopicSlug = button.getAttribute('data-subtopic-slug') || '';
                var dropdownItem = document.createElement('div');
                dropdownItem.className = "rmff-dropdown-item ".concat(index === 0 ? 'selected' : '');
                dropdownItem.setAttribute('data-topic-index', topicIndex.toString());
                dropdownItem.setAttribute('data-subtopic-index', subtopicIndex.toString());
                dropdownItem.setAttribute('data-graph-index', index.toString());
                dropdownItem.setAttribute('data-topic-slug', topicSlug);
                dropdownItem.setAttribute('data-subtopic-slug', subtopicSlug);
                dropdownItem.setAttribute('data-graph-slug', graphSlug);
                dropdownItem.setAttribute('data-dropdown-type', 'graph');
                dropdownItem.textContent = graphName;
                dropdownItem.addEventListener('click', function () {
                    selectGraph(widget, topicIndex, subtopicIndex, index);
                    // Update dropdown display
                    var selectedSpan = graphTrigger.querySelector('.rmff-dropdown-selected');
                    if (selectedSpan)
                        selectedSpan.textContent = graphName;
                    // Update selected state
                    graphList.querySelectorAll('.rmff-dropdown-item').forEach(function (i) { return i.classList.remove('selected'); });
                    dropdownItem.classList.add('selected');
                    // Close all dropdowns
                    widget.querySelectorAll('.rmff-dropdown-list').forEach(function (list) {
                        list.classList.remove('open');
                    });
                    widget.querySelectorAll('.rmff-dropdown-trigger').forEach(function (trigger) {
                        trigger.classList.remove('active');
                    });
                });
                graphList.appendChild(dropdownItem);
            });
            // Update trigger text
            var firstGraph = graphItems[0].querySelector('.rmff-graph-trigger');
            var selectedSpan = graphTrigger.querySelector('.rmff-dropdown-selected');
            if (selectedSpan && firstGraph) {
                selectedSpan.textContent = firstGraph.textContent || '';
            }
        }
    }
    function initializeFromURL(widget, params) {
        var topicIndex = 0;
        var subtopicIndex = 0;
        var graphIndex = 0;
        // Parse topic parameter by slug
        if (params.topic !== undefined) {
            var topicButton = widget.querySelector("[data-topic-slug=\"".concat(params.topic, "\"]"));
            if (topicButton) {
                topicIndex = parseInt(topicButton.getAttribute('data-topic-index') || '0');
            }
        }
        // Parse sub-topic parameter by slug
        if (params.subtopic !== undefined) {
            var subtopicButton = widget.querySelector("[data-subtopic-slug=\"".concat(params.subtopic, "\"]"));
            if (subtopicButton) {
                var buttonTopicIndex = parseInt(subtopicButton.getAttribute('data-topic-index') || '0');
                if (buttonTopicIndex === topicIndex) {
                    subtopicIndex = parseInt(subtopicButton.getAttribute('data-subtopic-index') || '0');
                }
            }
        }
        // Parse graph parameter by slug
        if (params.graph !== undefined) {
            var graphButton = widget.querySelector("[data-graph-slug=\"".concat(params.graph, "\"]"));
            if (graphButton) {
                var buttonTopicIndex = parseInt(graphButton.getAttribute('data-topic-index') || '0');
                var buttonSubtopicIndex = parseInt(graphButton.getAttribute('data-subtopic-index') || '0');
                if (buttonTopicIndex === topicIndex && buttonSubtopicIndex === subtopicIndex) {
                    graphIndex = parseInt(graphButton.getAttribute('data-graph-index') || '0');
                }
            }
        }
        // Set the selections
        currentTopic = topicIndex;
        currentSubtopic = subtopicIndex;
        currentGraph = graphIndex;
        // Update UI and show content
        updateTopicSelection(widget, topicIndex);
        updateSubtopicVisibility(widget, topicIndex);
        updateSubtopicSelection(widget, topicIndex, subtopicIndex);
        updateGraphVisibility(widget, topicIndex, subtopicIndex);
        updateGraphSelection(widget, topicIndex, subtopicIndex, graphIndex);
        // Hide placeholder and show content
        if (placeholder) {
            var placeholderElement = placeholder;
            placeholderElement.style.display = 'none';
        }
        // Show the selected graph content
        showGraphContent(widget, topicIndex, subtopicIndex, graphIndex);
    }
    function selectTopic(widget, topicIndex) {
        // Update topic selection
        updateTopicSelection(widget, topicIndex);
        // Update sub-topic visibility and selection
        updateSubtopicVisibility(widget, topicIndex);
        updateSubtopicSelection(widget, topicIndex, 0);
        // Update graph visibility and selection
        updateGraphVisibility(widget, topicIndex, 0);
        updateGraphSelection(widget, topicIndex, 0, 0);
        // Show content for first sub-topic and graph of selected topic
        showGraphContent(widget, topicIndex, 0, 0);
        // Update URL
        updateURL(topicIndex, 0, 0);
        // Update dropdowns
        updateDropdownSelections(widget, topicIndex, 0, 0);
        populateSubtopicDropdown(widget, topicIndex);
        populateGraphDropdown(widget, topicIndex, 0);
        // Scroll to sub-topic section
        scrollToSubtopicSection(widget);
    }
    function selectSubtopic(widget, topicIndex, subtopicIndex) {
        // Update sub-topic selection
        updateSubtopicSelection(widget, topicIndex, subtopicIndex);
        // Update graph visibility and selection
        updateGraphVisibility(widget, topicIndex, subtopicIndex);
        updateGraphSelection(widget, topicIndex, subtopicIndex, 0);
        // Show content for first graph of selected sub-topic
        showGraphContent(widget, topicIndex, subtopicIndex, 0);
        // Update URL
        updateURL(topicIndex, subtopicIndex, 0);
        // Update dropdowns
        updateDropdownSelections(widget, topicIndex, subtopicIndex, 0);
        populateGraphDropdown(widget, topicIndex, subtopicIndex);
        // Scroll to graph section
        scrollToGraphSection(widget);
    }
    function selectGraph(widget, topicIndex, subtopicIndex, graphIndex) {
        // Update graph selection
        updateGraphSelection(widget, topicIndex, subtopicIndex, graphIndex);
        // Show content for selected graph
        showGraphContent(widget, topicIndex, subtopicIndex, graphIndex);
        // Update URL
        updateURL(topicIndex, subtopicIndex, graphIndex);
        // Update dropdowns
        updateDropdownSelections(widget, topicIndex, subtopicIndex, graphIndex);
        // Scroll to content section
        scrollToContentSection(widget);
    }
    function updateTopicSelection(widget, topicIndex) {
        // Remove active class from all topic triggers
        widget.querySelectorAll('.rmff-topic-trigger').forEach(function (trigger) {
            trigger.classList.remove('active');
        });
        // Add active class to selected topic
        var selectedTopic = widget.querySelector(".rmff-topic-trigger[data-topic-index=\"".concat(topicIndex, "\"]"));
        if (selectedTopic) {
            selectedTopic.classList.add('active');
        }
    }
    function updateSubtopicVisibility(widget, topicIndex) {
        widget.querySelectorAll('.rmff-subtopic-item').forEach(function (item) {
            var itemElement = item;
            itemElement.style.display = (item.getAttribute('data-topic-index') === topicIndex.toString()) ? 'block' : 'none';
        });
    }
    function updateSubtopicSelection(widget, topicIndex, subtopicIndex) {
        // Remove active class from all sub-topic triggers
        widget.querySelectorAll('.rmff-subtopic-trigger').forEach(function (trigger) {
            trigger.classList.remove('active');
        });
        // Add active class to selected sub-topic
        var selectedSubtopic = widget.querySelector(".rmff-subtopic-trigger[data-topic-index=\"".concat(topicIndex, "\"][data-subtopic-index=\"").concat(subtopicIndex, "\"]"));
        if (selectedSubtopic) {
            selectedSubtopic.classList.add('active');
        }
    }
    function updateGraphVisibility(widget, topicIndex, subtopicIndex) {
        widget.querySelectorAll('.rmff-graph-item').forEach(function (item) {
            var itemElement = item;
            itemElement.style.display = (item.getAttribute('data-topic-index') === topicIndex.toString() && item.getAttribute('data-subtopic-index') === subtopicIndex.toString()) ? 'block' : 'none';
        });
    }
    function updateGraphSelection(widget, topicIndex, subtopicIndex, graphIndex) {
        // Remove active class from all graph triggers
        widget.querySelectorAll('.rmff-graph-trigger').forEach(function (trigger) {
            trigger.classList.remove('active');
        });
        // Add active class to selected graph
        var selectedGraph = widget.querySelector(".rmff-graph-trigger[data-topic-index=\"".concat(topicIndex, "\"][data-subtopic-index=\"").concat(subtopicIndex, "\"][data-graph-index=\"").concat(graphIndex, "\"]"));
        if (selectedGraph) {
            selectedGraph.classList.add('active');
        }
    }
    function showGraphContent(widget, topicIndex, subtopicIndex, graphIndex) {
        widget.querySelectorAll('.rmff-graph-content').forEach(function (content) {
            var contentElement = content;
            contentElement.style.display = 'none';
        });
        var selectedContent = widget.querySelector("#content-".concat(topicIndex, "-").concat(subtopicIndex, "-").concat(graphIndex));
        if (selectedContent) {
            var selectedContentElement = selectedContent;
            selectedContentElement.style.display = 'block';
            var vizUrl = selectedContentElement.getAttribute('data-vizurl');
            if (vizUrl) {
                createViz(selectedContentElement, vizUrl);
            }
        }
    }
    // Scroll functions
    function scrollToSubtopicSection(widget) {
        var subtopicSection = widget.querySelector('.rmff-subtopics-level');
        if (subtopicSection) {
            var offset = 65; // Offset to account for any fixed headers
            var elementPosition = subtopicSection.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - offset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
    function scrollToGraphSection(widget) {
        var graphSection = widget.querySelector('.rmff-graphs-level');
        if (graphSection) {
            var offset = 50; // Offset to account for any fixed headers
            var elementPosition = graphSection.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - offset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
    function scrollToContentSection(widget) {
        var contentSection = widget.querySelector('.rmff-data-content');
        if (contentSection) {
            var offset = 50; // Offset to account for any fixed headers
            var elementPosition = contentSection.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - offset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
}
// Helper functions
function getURLParameters() {
    var urlParams = new URLSearchParams(window.location.search);
    return {
        topic: urlParams.get('topic') || undefined,
        subtopic: urlParams.get('subtopic') || undefined,
        graph: urlParams.get('graph') || undefined
    };
}
function updateURL(topicIndex, subtopicIndex, graphIndex) {
    var url = new URL(window.location.href);
    // Get the slugs from the active buttons
    var activeTopic = document.querySelector('.rmff-topic-trigger.active');
    var activeSubtopic = document.querySelector('.rmff-subtopic-trigger.active');
    var activeGraph = document.querySelector('.rmff-graph-trigger.active');
    if (activeTopic) {
        url.searchParams.set('topic', activeTopic.getAttribute('data-topic-slug') || topicIndex.toString());
    }
    if (activeSubtopic) {
        url.searchParams.set('subtopic', activeSubtopic.getAttribute('data-subtopic-slug') || subtopicIndex.toString());
    }
    if (activeGraph) {
        url.searchParams.set('graph', activeGraph.getAttribute('data-graph-slug') || graphIndex.toString());
    }
    // Update URL without page reload
    window.history.pushState({}, '', url.toString());
}
function createViz(container, vizURL) {
    var vizDiv = container.querySelector('.tableauPlaceholder');
    if (!vizDiv)
        return;
    var isSmallViewport = window.innerWidth <= 1024;
    var options = { width: "100%", height: isSmallViewport ? "1650px" : "1100px" };
    if (window.viz && typeof window.viz.dispose === 'function') {
        window.viz.dispose();
    }
    try {
        window.viz = new window.tableau.Viz(vizDiv, vizURL, options);
        var iframe = vizDiv.querySelector('iframe');
        if (iframe) {
            iframe.setAttribute('scrolling', 'yes');
        }
    }
    catch (error) {
        console.error('Error creating Tableau visualization:', error);
    }
}
// Export for use in index.ts
export { initCommunityDataSnapshot };
